import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getLocale } from '../../../../configuration';
import type { RootState } from '../../../../configuration/setup/store';
import { getTermsAndConditionsUrl } from '../../config/productConfig';
import { useDialogCloseTrackingLabel } from '../utils/useDialogCloseTrackingLabel';

interface Props {
    locale: string;
    serviceSku: string;
    level?: string;
    documentVersion?: string;
    children?: React.ReactNode;
    show?: boolean;
    onClose?: () => void;
}

const TermsAndConditions = ({ serviceSku, level, documentVersion, children, locale, show, onClose }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const intl = useIntl();
    const dialogTitleId = 'intl-msg:marketplace.myServices.termsAndConditions.dialogTitle';
    const iframeTitle = intl.formatMessage({ id: dialogTitleId });
    const isShown = show ?? isOpen;
    const termsAndConditionsUrl =
        documentVersion === undefined
            ? getTermsAndConditionsUrl(locale, serviceSku, level)
            : getTermsAndConditionsUrl(locale, serviceSku, level, documentVersion);
    useDialogCloseTrackingLabel(isShown, 'marketplace.myServices.termsAndConditions.dialogTitle');

    return (
        <>
            <Dialog
                show={isShown}
                title={<FormattedMessage id={dialogTitleId} />}
                body={
                    <iframe
                        className='position-absolute top-0 left-0 width-100pct height-100pct'
                        src={termsAndConditionsUrl}
                        title={iframeTitle}
                    />
                }
                onClose={() => {
                    setIsOpen(false);
                    onClose?.();
                }}
                footer={null}
                showCloseButton={true}
                bsSize={Dialog.SIZE_FULL_SCREEN}
            />
            {children && (
                <span
                    onClick={event => {
                        event.preventDefault();
                        setIsOpen(true);
                    }}
                >
                    {children}
                </span>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    locale: getLocale(state),
});

export const TermsAndConditionsContainer = connect(mapStateToProps)(TermsAndConditions);
